import React from 'react'
import ModalBasic from '../../component/ModalBasic';
import { AgGridReact } from "ag-grid-react";
import moment from 'moment';

const issueColdefs = [
    {
        headerCheckboxSelection: true,
        checkboxSelection: true,
        minWidth: window.innerWidth * 0.04,
        flex: 0.4,
    },
    {
        field: "productionNo",
        headerName: "Production no",
        minWidth: window.innerWidth * 0.05,
        flex: 0.5,
        filter: true,
        floatingFilter: true
    },
    {
        field: "productionDate",
        headerName: "Production Date",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
        floatingFilter: true,
        valueFormatter: (params) => {
            return params.value ? moment(params.value).format("DD-MM-YYYY") : "";
        }
    },
    {
        field: "itemName",
        headerName: "Item name",
        minWidth: window.innerWidth * 0.15,
        flex: 1.5,
        filter: true,
        floatingFilter: true
    },
    {
        field: "productionQuantity",
        headerName: "Production Quantity",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
        floatingFilter: true
    },
    {
        field: "woRecvNo",
        headerName: "WO Recv No",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
        floatingFilter: true
    },
    {
        field: "idWoRecvNo",
        headerName: "ID wO Recv No",
        minWidth: window.innerWidth * 0.05,
        flex: 0.5,
        filter: true,
        floatingFilter: true
    },
];
const itemColdefs = [
    {
        headerCheckboxSelection: true,
        checkboxSelection: true,
        minWidth: window.innerWidth * 0.04,
        flex: 0.4,
    },
    {
        field: "drawingNo",
        headerName: "Drawing no",
        minWidth: window.innerWidth * 0.1,
        flex: 1.0,
        filter: true,
        floatingFilter: true
    },
    {
        field: "itemCategory",
        headerName: "Item category",
        minWidth: window.innerWidth * 0.14,
        flex: 1.4,
        filter: true,
        floatingFilter: true
    },
    {
        field: "itemName",
        headerName: "Item name",
        minWidth: window.innerWidth * 0.15,
        flex: 1.5,
        filter: true,
        floatingFilter: true
    },
    {
        field: "quantity",
        headerName: "Quantity",
        minWidth: window.innerWidth * 0.05,
        flex: 0.5,
        filter: true,
        floatingFilter: true
    },

    {
        field: "itemType",
        headerName: "Item type",
        minWidth: window.innerWidth * 0.1,
        flex: 0.1,
        filter: true,
        floatingFilter: true
    },
    {
        field: "drawingNo1",
        headerName: "Drawing no1",
        minWidth: window.innerWidth * 0.1,
        flex: 1.0,
        filter: true,
        floatingFilter: true
    },
    {
        field: "idItem",
        headerName: "ID item",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
        floatingFilter: true
    },
    {
        field: "idMaterialProduction",
        headerName: "ID materail production",
        minWidth: window.innerWidth * 0.07,
        flex: 0.7,
        filter: true,
        floatingFilter: true
    },
    {
        field: "idMaterialProductionItems",
        headerName: "ID materail production items",
        minWidth: window.innerWidth * 0.07,
        flex: 0.7,
        filter: true,
        floatingFilter: true
    },
    {
        field: "idWoOrderRecv",
        headerName: "ID wo order recv",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
        floatingFilter: true
    },
];
const vendorColdefs = [

];

function IssuePopup(props) {
    return (
        <ModalBasic
            id="issue-popup"
            classParams="!w-[75%] overflow-y-auto p-5 pt-2.5"
            modalOpen={props.isIssueOpen}
            setModalOpen={props.setIssueModel}
        >
            <div className="pending-table h-[50vh] pt-2.5">
                <span className="text-blue text-[16px] font-semibold">Material issue selection</span>
                <div className="table-inner mt-[10px] overflow-y-auto"
                    style={{ height: "calc(100vh - 370px)" }}>
                    <AgGridReact
                        rowData={props.issueRowData}
                        columnDefs={issueColdefs}
                        onCellClicked={props.handleCellClickItemList2}
                        rowSelection="multiple"
                        overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                        onSelectionChanged={(event) => {
                            const selectedRows = event.api.getSelectedRows();
                            props.onSelectionChanged(selectedRows);
                        }}
                    // onCellClicked={props.handleCellClickItemList}
                    //onGridReady={props.onGridReady}
                    //overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                    //overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                    />
                </div>
            </div>
            <div className='table-wrap'>
                <div className='left-table w-full mt-2.5'>
                    <span className="text-blue text-[16px] font-semibold">Item details</span>
                    <div className="table-inner mt-[10px] overflow-y-auto"
                        style={{ height: "calc(100vh - 470px)" }}>
                        <AgGridReact
                            rowData={props.issueRowData2}
                            headerHeight={65}
                            columnDefs={itemColdefs}
                            rowSelection="multiple"
                            overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                            onSelectionChanged={(event) => {
                                const selectedRows = event.api.getSelectedRows();
                                props.onSelectionItemsChanged(selectedRows);
                            }}
                        // onCellClicked={props.handleCellClickItemList}
                        //onGridReady={props.onGridReady}
                        //overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                        //overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                        />
                    </div>
                </div>
                {/* <div className='right-table w-full mt-2.5'>
                    <span className="text-blue text-[16px] font-semibold">Vendor price details</span>
                    <div className="table-inner mt-[10px] overflow-y-auto"
                        style={{ height: "calc(100vh - 470px)" }}>
                        <AgGridReact
                            rowData={props.vendorRowData}
                            columnDefs={vendorColdefs}
                        // onCellClicked={props.handleCellClickItemList}
                        //onGridReady={props.onGridReady}
                        //overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                        //overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                        />
                    </div>
                </div> */}
            </div>
            <div className='btn-grp mt-2.5 flex items-center gap-5'>
                <button className="save-btn btns" onClick={() => props.addMrsData()}>Add products</button>
                <button className="delete-btn btns" onClick={() => props.exit()}>Cancel</button>
            </div>

        </ModalBasic>
    )
}

export default IssuePopup